import { Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs/BehaviorSubject';

@Injectable()
export class ChartUpdateService {

    private updateNotification = new BehaviorSubject<string>("Startup");
    currentNotification = this.updateNotification.asObservable();

    constructor() { }

    TriggerAnotherUpdate(notification: string) {
        this.updateNotification.next(notification)
    }

}



// WEBPACK FOOTER //
// ./src/app/core/services/chart-update.service.ts